import { create } from "zustand";
import type { Frame, Project, Space } from "@/api/spaces";

export interface WorkspaceConversationOverlay {
  frame: Frame;
  project: Project;
  space: Space;
}

interface WorkspaceConversationOverlayState {
  overlay: WorkspaceConversationOverlay | null;
  open: (overlay: WorkspaceConversationOverlay) => void;
  close: () => void;
}

export const useWorkspaceConversationOverlay =
  create<WorkspaceConversationOverlayState>((set) => ({
    overlay: null,
    open: (overlay) => set({ overlay }),
    close: () => set({ overlay: null }),
  }));
